import React from 'react'
import classes from './cardbody.module.css'

const CardBody = ({ children, className = '' }) => {
    return <div className={`${classes.body} ${className}`}>{children}</div>
}

export default CardBody
